import { EDruhInvesticie } from 'enums/isin/udaje/druhInvesticie';

const druhInvesticieSelect = [
    {
        value: EDruhInvesticie.N,
        labelcz: 'ISIN_EMISE_LIST_AKTIVA_N'
    },
    {
        value: EDruhInvesticie.DL,
        labelcz: 'ISIN_EMISE_LIST_AKTIVA_DN'
    },
    {
        value: EDruhInvesticie.A,
        labelcz: 'ISIN_EMISE_LIST_AKTIVA_A'
    },
    {
        value: EDruhInvesticie.V,
        labelcz: 'ISIN_EMISE_LIST_AKTIVA_VCP'
    },
    {
        value: EDruhInvesticie.S,
        labelcz: 'ISIN_EMISE_LIST_AKTIVA_S'
    },
    {
        value: EDruhInvesticie.K,
        labelcz: 'ISIN_EMISE_LIST_AKTIVA_K'
    },
    {
        value: EDruhInvesticie.D,
        labelcz: 'ISIN_EMISE_LIST_AKTIVA_D'
    },
    {
        value: EDruhInvesticie.R,
        labelcz: 'ISIN_EMISE_LIST_AKTIVA_RN'
    },
    {
        value: EDruhInvesticie.U,
        labelcz: 'ISIN_EMISE_LIST_AKTIVA_U'
    },
    {
        value: EDruhInvesticie.O,
        labelcz: 'ISIN_EMISE_LIST_AKTIVA_O'
    }
];

export default druhInvesticieSelect;
